import { MarketingChannel } from "@redotech/redo-billing-common/marketing-channel";
import { MessageDirection } from "@redotech/redo-marketing-common/message/marketing-message-definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getConversationMessages = {
  name: "getConversationMessages" as const,
  input: z.object({
    conversationId: zExt.objectId(),
    limit: z.number().int().positive().max(1000).default(1000),
    lastSentAt: z.date().optional(),
    lastId: zExt.objectId().optional(),
  }),
  output: z.object({
    messages: z.array(
      z.object({
        _id: z.string(),
        channel: createEnum(MarketingChannel),
        content: z.string(),
        direction: createEnum(MessageDirection),
        sentAt: z.date().nullable(),
        draftedAt: z.date().nullable(),
        scheduledAt: z.date().nullable(),
        createdAt: z.date(),
        failedAt: z.date().nullable(),
      }),
    ),
    hasMore: z.boolean(),
    customerName: z.string().optional(),
    teamName: z.string().optional(),
    teamId: z.string().optional(),
  }),
};
